import * as React from 'react';

export interface ComposerHeaderProps {
  children?: React.ReactNode;
  dataHook?: string;
  backButtonValue?: React.ReactNode;
  onBackClick?: React.MouseEventHandler<HTMLElement>;
  size?: 'small' | 'medium';
  dropShadow?: boolean;
}

declare const ComposerHeaderSaveStatus: React.FC<ComposerHeaderSaveStatusProps>;
interface ComposerHeaderSaveStatusProps {
  saveStatusValue: string;
  saveStatusError?: string;
  dataHook?: string;
  size?: 'small' | 'medium';
}

declare const ComposerHeaderActions: React.FC<ComposerHeaderActionsProps>;
interface ComposerHeaderActionsProps {
  justifyContent?: React.CSSProperties['justifyContent'];
  dataHook?: string;
}
declare const ComposerHeaderMainActions: React.FC<ComposerHeaderMainActionsProps>;
interface ComposerHeaderMainActionsProps {
  children?: React.ReactNode;
  dataHook?: string;
}

export default class ComposerHeader extends React.Component<ComposerHeaderProps> {
  static SaveStatus: typeof ComposerHeaderSaveStatus;
  static Actions: typeof ComposerHeaderActions;
  static MainActions: typeof ComposerHeaderMainActions;
}
